/**
 * @file main.ts
 * @description 应用程序入口文件，负责初始化 Vue 应用及相关插件配置
 */

import { createApp } from 'vue'

// ==================== 状态管理 ====================
import pinia from './store/pinia' // 自定义 Pinia 实例

// ==================== 核心组件 ====================
import App from './App.vue' // 根组件
import router from './router' // 路由配置

// ==================== UI 框架 ====================
// import 'element-plus/theme-chalk/dark/css-vars.css' // Element Plus 暗色主题（暂未启用）
import ElementPlus from 'element-plus' // Element Plus 组件库
import * as ElementPlusIconsVue from '@element-plus/icons-vue' // Element Plus 图标库

// ==================== 国际化 ====================
import { i18n } from '@/locales' // i18n 国际化配置
import { useLocaleStore } from './store/locales' // 语言状态管理

// ==================== 样式文件 ====================
import './assets/css/main.scss' // 全局主样式

/**
 * 创建 Vue 应用实例
 */
const app = createApp(App)

/**
 * 全局注册 Element Plus 图标组件
 * 遍历所有图标并注册为全局组件，可在模板中直接使用图标名称
 */
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// ==================== 安装插件 ====================
app.use(pinia) // 安装自定义 Pinia 实例
app.use(router) // 安装路由
app.use(ElementPlus) // 安装 Element Plus UI 框架
app.use(i18n) // 安装国际化插件

/**
 * 初始化语言设置
 * 从 localeStore 获取当前语言并同步到 i18n
 */
const localeStore = useLocaleStore();
const currentLocale = localeStore.locale;
localeStore.setLocale(currentLocale); // 同步 i18n 的语言设置

/**
 * 挂载应用到 DOM
 * 将 Vue 应用挂载到 index.html 中 id 为 'app' 的元素
 */
app.mount('#app')
